module.exports = __webpack_public_path__ + "static/media/ee_ru_desk_r.6b8fe9f2.png";